// Analytics FLASH — dataLayer centralizzato + Consent Mode v2.
// I tag (GA4/GTM/Ads) arrivano da /api/public-config (runtime): nessun ID hardcoded,
// nessun caricamento prima del consenso, nessun ID finto in produzione.
// MAI inviare a Google: nomi, email, telefono, CF, dati sanitari, nomi/contenuti documenti,
// dettagli pratica, contenuti questionari. Filtro di sicurezza applicato a ogni evento.

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let cfgPromise = null;
export const getTagConfig = () => {
  if (!cfgPromise) {
    cfgPromise = fetch(`${API}/public-config`)
      .then((r) => (r.ok ? r.json() : {}))
      .catch(() => ({}));
  }
  return cfgPromise;
};

const SENSITIVE_KEYS = new Set([
  "email", "name", "nome", "cognome", "firstName", "lastName", "phone", "telefono",
  "fiscalCode", "codiceFiscale", "cf", "message", "messaggio", "address", "indirizzo",
  "companyName", "pec", "password", "document", "documents", "fileName", "filename",
  "answers", "risposte", "notes", "note",
]);

export const track = (event, params = {}) => {
  if (typeof window === "undefined") return;
  const clean = {};
  for (const [k, v] of Object.entries(params)) {
    if (SENSITIVE_KEYS.has(k)) continue;
    if (typeof v === "string" && v.includes("@")) continue;
    clean[k] = v;
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...clean });
  // GA4 diretto (senza GTM): gli eventi vanno anche a gtag
  if (window.__ga4Direct && typeof window.gtag === "function") {
    window.gtag("event", event, clean);
  }
};

// Eventi strumenti gratuiti: GA4/dataLayer + persistenza aggregata per Admin.
// Mai inviare risposte del questionario, contatti o PII: solo toolName ed eventuali slug servizio.
export const trackTool = (event, toolName, params = {}) => {
  const clean = { tool_name: toolName };
  if (params.serviceSlug) clean.service_slug = params.serviceSlug;
  track(event, clean);
  try {
    fetch(`${API}/tools/events`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ event, toolName, serviceSlug: params.serviceSlug || null, pageUrl: window.location.pathname }),
      keepalive: true,
    }).catch(() => {});
  } catch { /* analytics mai bloccanti */ }
};


// Conversione Google Ads: solo se ID+label configurati E consenso marketing presente.
export const trackAdsConversion = async (name, data = {}) => {
  if (typeof window === "undefined") return;
  const cfg = await getTagConfig();
  const label = cfg.googleAdsConversionLabels?.[name];
  if (!cfg.googleAdsId || !label || !window.__adsConfigured) return;
  if (typeof window.gtag !== "function") return;
  window.gtag("event", "conversion", {
    send_to: `${cfg.googleAdsId}/${label}`,
    ...data,
  });
};
